class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
        
        this.initializeCartCheckboxes();
        this.initializeCheckbox();
      },
      { once: true }
    );
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    console.log("😍😍😍😍")
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      
      this.initializeCartCheckboxes();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
// ======================================================Checkbox code ======================================================
  updateCartDrawer() {
    fetch('/cart')
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawerContent = doc.querySelector('.cart-drawer__footer');
        if (newDrawerContent) {
          const footer = document.querySelector('.cart-drawer__footer');
          if (footer) {
            footer.innerHTML = newDrawerContent.innerHTML;
          }
        }
      })
      .catch((error) => {
        console.error('Error updating cart drawer', error);
      });
  }

  async initializeCartCheckboxes() {
    const checkboxes = this.querySelectorAll('.free-text-content input[data-free-id]');
    if (!checkboxes.length) return;

    try {
      const cartResponse = await fetch('/cart.json', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const cart = await cartResponse.json();

      checkboxes.forEach((checkbox) => {
        const variantId = checkbox.getAttribute('data-free-id');
        const itemInCart = cart.items?.some((item) => String(item.variant_id) === String(variantId));
        checkbox.checked = itemInCart;
      });
    } catch (error) {
      console.error('Error initializing checkboxes:', error);
    }
  }
  async waitForElement(selector, timeout = 10000) {
    const start = Date.now();
    while (Date.now() - start < timeout) {
      const element = this.querySelector(selector);
      if (element) return element;
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    throw new Error(`Element ${selector} not found within ${timeout}ms`);
  }
  async initializeCheckbox() {
    try {
      const checkbox = await this.waitForElement('.free-text-content input[data-free-id]');
      const checkboxWrapper = checkbox.closest('.checkbox-wrapper');
      const spinner = checkboxWrapper.querySelector('.spinner');
  
      checkbox.addEventListener('change', async (event) => {
        const variantId = event.target.getAttribute('data-free-id');
        const isChecked = event.target.checked;
        checkbox.classList.add('processing');
        spinner.style.display = 'block';
        try {
          const cartResponse = await fetch('/cart.json', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
          });
          const cart = await cartResponse.json();
  
          const itemInCart = cart.items?.some((item) => String(item.variant_id) === String(variantId));
  
          if (isChecked && !itemInCart) {
            const verifyResponse = await fetch('/cart.json', {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' },
            });
            const verifyCart = await verifyResponse.json();
            const stillNotInCart = !verifyCart.items?.some((item) => String(item.variant_id) === String(variantId));
  
            if (stillNotInCart) {
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: [{ id: variantId, quantity: 1 }],
                }),
              });
            } 
          } else if (!isChecked && itemInCart) {
            const lineItem = cart.items.find((item) => String(item.variant_id) === String(variantId));
            if (lineItem) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  line: cart.items.indexOf(lineItem) + 1,
                  quantity: 0,
                }),
              });
            }
          } 
          this.updateCartDrawer();
        } catch (error) {
          console.error('Error handling cart operation:', error);
        } finally {
          setTimeout(()=>{
            checkbox.classList.remove('processing');
            spinner.style.display = 'none';
          },800)
        }
      });
    } catch (error) {
      console.error('Error finding checkbox element:', error);
    }
  }
// ======================================================Checkbox code ======================================================
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);